module.exports = __webpack_public_path__ + "static/IMG_9503web-12c2a819bda66c59218f52ba31c4e792.jpg";